import { InitService } from './init.service';

export function initServiceFactory(initService: InitService) {
  return () => initService.checkRedirects();
}
